// // Detect sticky state of facets-wrapper and dynamically adjust z-index
// document.addEventListener('DOMContentLoaded', function() {
//   const facetsWrapper = document.querySelector('.facets-wrapper');
//   const productGridContainer = document.getElementById('ProductGridContainer');
//   const announcementBar = document.querySelector('.announcement-bar-section');
  
//   if (!facetsWrapper) return;
  
//   let isSticky = false;
//   let shouldOverrideZIndex = false;
//   let lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
//   let scrollDirection = 'down'; // 'up' | 'down'
  
//   // Create intersection observer to detect when element becomes sticky
//   const observer = new IntersectionObserver(function(entries) {
//     entries.forEach(function(entry) {
//       if (entry.isIntersecting) {
//         // Element is sticky, set flag
//         isSticky = true;
//         updateZIndex();
//       } else {
//         // Element is not sticky, reset flag
//         isSticky = false;
//         updateZIndex();
//       }
//     });
//   }, {
//     threshold: [0, 1],
//     rootMargin: '-1px 0px 0px 0px'
//   });
  
//   // Function to update z-index based on current state
//   function updateZIndex() {
//     const facetsHeader = document.querySelector('.facets__header');
//     const isMobile = window.innerWidth <= 749;
    
//     if (shouldOverrideZIndex) {
//       // Override active - force z-index to 2
//       facetsWrapper.style.zIndex = '2';
//       if (facetsHeader) {
//         facetsHeader.style.zIndex = '2';
//       }
//     } else if (isSticky) {
//       // Sticky state - use different z-index for mobile vs desktop
//       if (isMobile) {
//         // Mobile: use z-index 3 to stay above other elements
//         facetsWrapper.style.zIndex = '3';
//         if (facetsHeader) {
//           facetsHeader.style.zIndex = '3';
//         }
//       } else {
//         // Desktop: use z-index 2 to stay below header (z-index 3/4)
//         facetsWrapper.style.zIndex = '2';
//         if (facetsHeader) {
//           facetsHeader.style.zIndex = '2';
//         }
//       }
//     } else {
//       // Not sticky - use z-index 2
//       facetsWrapper.style.zIndex = '2';
//       if (facetsHeader) {
//         facetsHeader.style.zIndex = '2';
//       }
//     }
//   }
  
//   // Helper: check if current scroll is within the product list display area
//   function isWithinProductListArea() {
//     if (!productGridContainer) return false;
//     const rect = productGridContainer.getBoundingClientRect();
//     const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
//     // Consider we're in the area if the container intersects the viewport
//     return rect.bottom > 0 && rect.top < viewportHeight;
//   }

//   // Store original announcement bar height
//   let originalAnnouncementBarHeight = 0;
//   if (announcementBar) {
//     originalAnnouncementBarHeight = announcementBar.offsetHeight;
//   }

//   // Control announcement bar visibility and header position
//   function controlAnnouncementBar(shouldHide) {
//     if (!announcementBar) return;
    
//     if (shouldHide) {
//       // Hide announcement bar by moving it up
//       announcementBar.style.transform = 'translateY(-100%)';
//       announcementBar.style.transition = 'transform 0.2s ease-out';
//       announcementBar.style.pointerEvents = 'none';
//       // Update CSS variable to 0 so header moves up
//       document.documentElement.style.setProperty('--announcement-bar-height', '0px');
//     } else {
//       // Show announcement bar - first restore transform to get accurate height
//       announcementBar.style.transform = '';
//       announcementBar.style.transition = 'transform 0.2s ease-out';
//       announcementBar.style.pointerEvents = '';
//       // Use stored height immediately, then recalculate after transition
//       if (originalAnnouncementBarHeight > 0) {
//         document.documentElement.style.setProperty('--announcement-bar-height', `${originalAnnouncementBarHeight}px`);
//       }
//       // Recalculate after transition completes to ensure accuracy
//       setTimeout(() => {
//         const currentHeight = announcementBar.offsetHeight;
//         if (currentHeight > 0 && currentHeight !== originalAnnouncementBarHeight) {
//           document.documentElement.style.setProperty('--announcement-bar-height', `${currentHeight}px`);
//           originalAnnouncementBarHeight = currentHeight;
//         }
//       }, 250); // Wait for transition to complete (0.2s + buffer)
//     }
//   }

//   // Apply top offset and priority based on scroll direction
//   function applyDirectionAwareSticky() {
//     const isMobile = window.innerWidth <= 749;
//     if (!isMobile) {
//       // On desktop, always show announcement bar
//       controlAnnouncementBar(false);
//       return;
//     }

//     if (!isSticky) {
//       // Reset any inline overrides when not sticky
//       facetsWrapper.style.top = '';
//       // Show announcement bar when not sticky
//       controlAnnouncementBar(false);
//       return;
//     }
//     // If already at the very top of the page, avoid adding header offset to prevent gap
//     const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
//     const headerHeightPx = (function getHeaderHeight() {
//       // Try CSS var --header-height first
//       const rootStyles = window.getComputedStyle(document.documentElement);
//       const varValue = rootStyles.getPropertyValue('--header-height');
//       const parsed = parseInt(varValue, 10);
//       if (!Number.isNaN(parsed) && parsed > 0) return parsed;
//       // Fallback to actual header element height
//       const headerEl = document.querySelector('.section-header, header.header');
//       return headerEl ? headerEl.offsetHeight : 0;
//     })();
//     if (currentY <= Math.max(1, headerHeightPx)) {
//       facetsWrapper.style.top = '0px';
//       // Show announcement bar at top of page
//       controlAnnouncementBar(false);
//       return;
//     }

//     if (isWithinProductListArea()) {
//       if (scrollDirection === 'up') {
//         // When scrolling up inside product list, let header appear first
//         facetsWrapper.style.top = 'var(--header-height)';
//         // Lower z-index a bit so header sits above; keep interactions intact
//         facetsWrapper.style.zIndex = '2';
//         // Show announcement bar when scrolling up
//         controlAnnouncementBar(false);
//       } else {
//         // Scrolling down through products: keep filter bar pinned to top
//         facetsWrapper.style.top = '0px';
//         facetsWrapper.style.zIndex = '3';
//         // Hide announcement bar when scrolling down to give filter bar full visibility
//         controlAnnouncementBar(true);
//       }
//     } else {
//       // Outside product list area: revert to default behavior
//       facetsWrapper.style.top = '0px';
//       // Show announcement bar outside product list area
//       controlAnnouncementBar(false);
//     }
//   }

//   // Monitor search modal state (this controls both search modal and search suggestions)
//   const searchDetails = document.querySelector('details-modal details');
//   if (searchDetails) {
//     const searchObserver = new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
//           if (searchDetails.hasAttribute('open')) {
//             // Search modal is open - this means search suggestions are visible
//             shouldOverrideZIndex = true;
//             updateZIndex();
//           } else {
//             // Search modal is closed
//             shouldOverrideZIndex = false;
//             updateZIndex();
//           }
//         }
//       });
//     });
    
//     searchObserver.observe(searchDetails, {
//       attributes: true,
//       attributeFilter: ['open']
//     });
//   }
  
//   // Monitor menu drawer state
//   const menuDrawer = document.querySelector('#Details-menu-drawer-container');
//   if (menuDrawer) {
//     const menuObserver = new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
//           if (menuDrawer.hasAttribute('open')) {
//             // Menu drawer is open - force z-index to 2 for both facets-wrapper and facets__header
//             facetsWrapper.style.zIndex = '2';
//             const facetsHeader = document.querySelector('.facets__header');
//             if (facetsHeader) {
//               facetsHeader.style.zIndex = '2';
//             }
//           } else {
//             // Menu drawer is closed - restore normal z-index logic
//             shouldOverrideZIndex = false;
//             updateZIndex();
//           }
//         }
//       });
//     });
    
//     menuObserver.observe(menuDrawer, {
//       attributes: true,
//       attributeFilter: ['open']
//     });
//   }
  
//   // Handle window resize to update z-index for mobile/desktop
//   function handleResize() {
//     // Update original announcement bar height on resize
//     if (announcementBar && !announcementBar.style.transform) {
//       originalAnnouncementBarHeight = announcementBar.offsetHeight;
//       if (originalAnnouncementBarHeight > 0) {
//         document.documentElement.style.setProperty('--announcement-bar-height', `${originalAnnouncementBarHeight}px`);
//       }
//     }
//     updateZIndex();
//     applyDirectionAwareSticky();
//   }
  
//   window.addEventListener('resize', handleResize);
  
//   // Start observing
//   observer.observe(facetsWrapper);
  
//   // Listen to window scroll to detect direction and apply behavior
//   function onScroll() {
//     const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
//     scrollDirection = currentY < lastScrollY ? 'up' : 'down';
//     lastScrollY = currentY;
//     applyDirectionAwareSticky();
//   }
//   window.addEventListener('scroll', onScroll, { passive: true });
  
//   // Cleanup on page unload
//   window.addEventListener('beforeunload', function() {
//     observer.disconnect();
//     if (searchObserver) searchObserver.disconnect();
//     if (menuObserver) menuObserver.disconnect();
//     window.removeEventListener('resize', handleResize);
//     window.removeEventListener('scroll', onScroll);
//   });
// });

document.querySelectorAll('.mobile-facets__disclosure').forEach(details => {
  details.addEventListener('toggle', () => {
    const wrapper = document.querySelector('.facets-wrapper');
    
    if (details.open) {
      wrapper.style.zIndex = '10';
    } else {
      wrapper.style.zIndex = '';
    }
  });
});
